// Import model
import { SfProductItem } from '../models/SfProductItem';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfProductItem - handles JSON serialization and deserialization with type validation
 */
export class SfProductItemSerializer {
  /**
   * Deserializes a JSON string into a SfProductItem instance
   */
  static deserialize(json: string): SfProductItem {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfProductItem instance
   */
  static fromObject(obj: any): SfProductItem {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfProductItem');
    }


    const instance: SfProductItem = {
      name: obj['name'] as string | undefined,
      code: obj['code'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      uom: obj['uom'] as string | undefined,
      isDeleted: obj['isDeleted'] as boolean | undefined,
      sku: obj['sku'] as string | undefined,
      isLabor: obj['isLabor'] as boolean | undefined,
      notes: obj['notes'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfProductItem instances
   */
  static deserializeArray(json: string): SfProductItem[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfProductItem instance to a JSON string
   */
  static serialize(instance: SfProductItem): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfProductItem instance to a plain object
   */
  static toObject(instance: SfProductItem): any {
    return {
      'name': instance.name,
      'code': instance.code,
      'isActive': instance.isActive,
      'uom': instance.uom,
      'isDeleted': instance.isDeleted,
      'sku': instance.sku,
      'isLabor': instance.isLabor,
      'notes': instance.notes,
    };
  }

  /**
   * Serializes an array of SfProductItem instances to a JSON string
   */
  static serializeArray(instances: SfProductItem[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
